import React from 'react';
import { LiveMatchesCarousel } from './component';

export default React.memo(LiveMatchesCarousel);